import { isArray, isNil, decryptToken, encryptToken } from 'vdlib';
import Store from 'data/Store';
import { TOKEN_STORAGE_KEY } from './Constants';

const AuthHelper = {
  getUser: () => (Store.getState().app || {}).user,
  isInRole: rolesList => {
    if (rolesList === '*') return true;

    let role = (AuthHelper.getUser() || {}).role;
    return !role
      ? false
      : isArray(rolesList)
      ? rolesList.indexOf(role) > 0
      : rolesList === role;
  },
  isLoggedIn: () => !isNil(AuthHelper.getUser()),
  getAuthToken: () => {
    let encryptedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
    return !isNil(encryptedToken) ? decryptToken(encryptedToken) : '';
  },
  storeAuthToken: accessToken =>
    localStorage.setItem(TOKEN_STORAGE_KEY, encryptToken(accessToken)),
  logout: () => localStorage.removeItem(TOKEN_STORAGE_KEY),
  clearSession: () => sessionStorage.clear(),
};

export default AuthHelper;
